import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".SearchFullScreenMobile-module_container__I4mZT {\n  width: 100vw;\n  height: 100vh;\n  background-color: white;\n  position: fixed;\n  top: 0px;\n  left: 0;\n  z-index: 9999999999;\n  padding: 12px 16px 0;\n}\n\n.SearchFullScreenMobile-module_prefix_container__0DK8P {\n  display: flex;\n  width: 38px;\n  justify-content: center;\n}";
var Styles = {"container":"SearchFullScreenMobile-module_container__I4mZT","prefix_container":"SearchFullScreenMobile-module_prefix_container__0DK8P"};
styleInject(css_248z);

export { Styles as default };
//# sourceMappingURL=SearchFullScreenMobile.module.scss.js.map
